import { SoloScenarioId, soloScenarios } from "../data/driverAppScenarios";
import { DriverAppScenarioPanel } from "./DriverAppScenarioPanel";
import { DriverAppScenarioPicker } from "./DriverAppScenarioPicker";
import { TransportProviderCodePane } from "./TransportProviderCodePane";

export interface DownloadDriverAppStepProps {
  providerCode: string;
  driverRegisterLink?: string;
  /** The operator's own portal login email, used where the Scenario copy names it. */
  operatorEmail?: string;
  selectedScenario: SoloScenarioId | null;
  onSelectScenario: (scenario: SoloScenarioId) => void;
  onClearScenario: () => void;
}

/**
 * The left pane stays empty until a Scenario is chosen, so the operator answers the one question
 * before being shown a code and a QR they cannot act on yet.
 */
export const DownloadDriverAppStep = ({
  providerCode,
  driverRegisterLink,
  operatorEmail,
  selectedScenario,
  onSelectScenario,
  onClearScenario,
}: DownloadDriverAppStepProps) => (
  <div className="-m-4 grid lg:grid-cols-[250px_1fr]">
    <div className="bg-neutral-gray">
      {selectedScenario && <TransportProviderCodePane providerCode={providerCode} driverRegisterLink={driverRegisterLink} />}
    </div>

    <div className="border-neutral-mid-gray lg:border-l">
      {selectedScenario ? (
        <DriverAppScenarioPanel
          scenario={soloScenarios[selectedScenario]}
          operatorEmail={operatorEmail}
          onBack={onClearScenario}
        />
      ) : (
        <div className="p-4">
          <DriverAppScenarioPicker value={null} onSelect={onSelectScenario} />
        </div>
      )}
    </div>
  </div>
);
